const formatToCurrency = (data, currency = 'USD') => {
  if (!data) {
    return ''
  }
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
  return formatter.format(data)
}

const getEmployeeRange = value => {
  const lookup = {
    '00001_00010': '1-10',
    '00011_00050': '11-50',
    '00051_00200': '51-200',
    '00201_00500': '201-500',
    '00501_01000': '501-1000',
    '01001_05000': '1001-5000',
    '05001_10000': '5001-10000',
    '10000_99999': '10000+',
  }
  return lookup[value] || ''
}

const getRevenueRange = value => {
  const lookup = {
    '00000_00001': '<$1M',
    '00001_00005': '$1M-5M',
    '00005_00010': '$5M-10M',
    '00010_00025': '$10M-25M',
    '00025_00100': '$25M-100M',
    '00100_00500': '$100M-500M',
    '00500_99999': '>$500M',
  }
  return lookup[value] || ''
}

const getRevenueLabel = value => {
  const lookup = ['0M', '$1M', '5M', '10M', '25M', '100M', '500M', '∞']
  return lookup[value] || ''
}

const getEmployeeLabel = value => {
  const lookup = ['1', '10', '50', '200', '500', '1000', '5000', '10000', '∞']
  return lookup[value] || ''
}

const getRangesFromSliderValues = (values, options) => {
  const start = values[0]
  const end = values[1]
  if (start === 0 && end === options.length) {
    return []
  }
  return options.slice(start, end).map(option => option.value)
}

export default {
  formatToCurrency,
  getEmployeeRange,
  getRevenueRange,
  getRevenueLabel,
  getEmployeeLabel,
  getRangesFromSliderValues,
}
